import axios from '../../index'
import qs from 'qs'
/**
 * @description 加载商品分类选项
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function loadAddress () {
  return axios.post(`/user/load-address`)
}
/**
 * @description 加载商品分类选项
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function loadAddressDeatil (params) {
  return axios.post(`/user/load-address-detail`, qs.stringify(params))
}
/**
 * @description 加载省市区
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function loadRegion (params) {
  return axios.post(`/user/region-new`, qs.stringify(params))
}
/**
 * @description 加载省市区
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function updateDefalut (params) {
  return axios.post(`/user/update-defalut`, qs.stringify(params))
}
/**
 * @description 添加地址
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function addAddress (params) {
  return axios.post(`/user/add-address`, qs.stringify(params))
}
/**
 * @description 修改地址
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function updateAddress (params) {
  return axios.post(`/user/update-address`, qs.stringify(params))
}
/**
 * @description 删除地址
 * @author txw
 * @date 2020-03-24
 * @export
 *
 */
export function delAddress (params) {
  return axios.post(`/user/del-address`, qs.stringify(params))
}
